import axiosWithAuth from '@/utils/axiosWithAuth';

export interface G2ReviewStatus {
  reviewExists: boolean;
}

const getG2ReviewStatus = async (): Promise<G2ReviewStatus> => {
  const {data} = await axiosWithAuth.get<G2ReviewStatus>('/g2_review');

  return data;
};

export default getG2ReviewStatus;
